import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Box from '@bit/knotchinc.web-react-components.box';
import { Page } from '@bit/knotchinc.web-react-components.page';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import { fetchPartnershipMetadata } from 'components/Pages/Entity/actions';
import PartnershipPaidContentView from './PartnershipPaidContentView.jsx';
import PartnershipInsightsView from './PartnershipInsightsView.jsx';

export class PartnershipView extends React.Component {
  componentDidMount() {
    this.fetchMetaByType();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.partnerId !== this.props.match.params.partnerId) {
      this.fetchMetaByType();
    }
  }

  fetchMetaByType() {
    const { match, getPartnershipMetadata } = this.props;
    const { entityId, entityType, partnerId } = match.params;

    if (entityType === 'brand') {
      getPartnershipMetadata(entityId, partnerId, entityType);
    } else {
      getPartnershipMetadata(partnerId, entityId, entityType);
    }
  }

  render() {
    const { match, metadata, partner } = this.props;
    const { data, fetched } = metadata;
    const { params: { entityType, entityId }, url } = match;
    let brand;
    let publisher;

    if (data.type === 'brand') {
      brand = data;
      publisher = partner.data;
    } else {
      brand = partner.data;
      publisher = data;
    }

    const tabs = [
      { text: 'Content', title: 'Content', link: `${url}/content` },
      { text: 'Analytics', title: 'Analytics', link: `${url}/analytics` },
    ];

    return (
      <Page>
        <Box height="320px">
          <PageHeader
            partnershipLogos={[brand.logo_url, publisher.logo_url]}
            bg={brand.banner_image_url}
            title={`${brand.name} & ${publisher.name}`}
            fetched={fetched}
            tabs={tabs}
            previousPageLink={`/blueprint/${entityType}/${entityId}/paid`}
            previousPageLinkTitle="Paid Content"
          />
        </Box>
        <Switch>
          <Redirect exact from={match.path} to={`${match.path}/content`} />
          <Route exact path={`${match.path}/content`} component={PartnershipPaidContentView} />
          <Route exact path={`${match.path}/analytics`} component={PartnershipInsightsView} />
        </Switch>
      </Page>
    );
  }
}

const mapStateToProps = ({
  PartnershipProfile: { metadata, partner },
}) => ({ metadata, partner });

const mapDispatchToProps = (dispatch) => ({
  getPartnershipMetadata: (brandId, publisherId, entityType) => dispatch(fetchPartnershipMetadata(brandId, publisherId, entityType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnershipView);
